export const styles = {
    borderRadius: '4px',
};
